module.exports = __webpack_public_path__ + "39c7f1146cdc0cdbce6a7adcaf435c64.pdf";